import { RA$ } from '@infl-ts/util-fp-ts';
import axios from 'axios';
import isPlainObject from 'lodash.isplainobject';
export var makeAxiosError = function makeAxiosError(error) {
  return {
    _tag: 'axios',
    error: error
  };
};
export var makeUnknownError = function makeUnknownError(error) {
  return {
    _tag: 'error',
    error: error
  };
};
export var makeCancellation = function makeCancellation(cancel) {
  return {
    _tag: 'cancellation',
    cancel: cancel
  };
};
export var isCancellation = function isCancellation(error) {
  return error._tag === 'cancellation';
};
export var makeStreamError = function makeStreamError(error) {
  return {
    _tag: 'stream',
    error: error
  };
};

function isHubApiError(err) {
  return isPlainObject(err) && '_tag' in err && typeof err._tag === 'string' && (['axios-error', 'unknown-error'].includes(err._tag) && err.error instanceof Error || err._tag === 'decoding' && RA$.isArray(err.errors) || err._tag === 'cancellation' && axios.isCancel(err.cancel));
}

export var resolveHubApiError = function resolveHubApiError(err) {
  return isHubApiError(err) ? err : axios.isCancel(err) ? makeCancellation(err) : axios.isAxiosError(err) ? makeAxiosError(err) : err instanceof Error ? makeUnknownError(err) : makeUnknownError(new Error('unknown error: ' + String(err)));
};
export var logError = function logError(err) {
  if (true) console.error(err);
  return true ? (console.error(err), String(err)) : null;
};